import styled, { css } from 'styled-components';
import ReactModal from 'react-modal';
import { layout, media } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';

type ModalProps = {
  $verticalScroll: boolean;
};

export const Modal = styled(ReactModal)<ModalProps>(
  props => css`
    padding: ${layout.measurements.spacing100};
    background: #fff;
    border-radius: ${layout.borderRadius};
    overflow: hidden;
    outline: 0;
    display: flex;
    flex-flow: row wrap;
    position: absolute;
    margin: ${layout.headerHeight.desktop.value}px auto;

    ${media.mediumDown`
      max-width: 90vw;
    `};

    ${media.smallOnly`
      max-width: 90vw;
      padding: ${layout.measurements.spacing050};
      margin-top: ${layout.headerHeight.mobile.value / 2}px;
    `};

    ${props.$verticalScroll &&
      css`
        margin: 0;
        padding: $padding-wrapper 0;

        ${media.smallOnly`
          padding: ${layout.measurements.spacing050} 0;
        `};
      `};

    h1 {
      font-size: 2.2rem;
    }
    > h1,
    > h2,
    > h3,
    > h4,
    > h5,
    > h6 {
      &:first-child {
        margin-top: 0;
        margin-bottom: 0.5em;
        line-height: 1.2em;
      }
    }
  `
);

export const Wrapper = styled.div`
  width: 100%;
`;

export const Viewport = styled.div`
  width: 100%;
  padding: 0 ${layout.measurements.spacing100};
  max-height: 80vh;
  overflow-y: auto;

  ${media.smallOnly`
    max-height: 90vh;
    padding: 0 ${layout.measurements.spacing050};
  `};
`;

export const CloseButton = styled(Button)`
  position: absolute;
  top: ${layout.measurements.spacing025};
  right: ${layout.measurements.spacing025};
  width: 40px;
  height: 40px;
  user-select: none;
  cursor: pointer;
  border: none;
`;
